import React from 'react';
import MovieDetails from '../Components/MovieDetails'

const SingleMovie = () => {
  return (
    <>
      <MovieDetails />
    </>
  )
}

export default SingleMovie;